import { render, staticRenderFns } from "./attrLabelSet.vue?vue&type=template&id=91be771a&scoped=true&"
import script from "./attrLabelSet.vue?vue&type=script&lang=js&"
export * from "./attrLabelSet.vue?vue&type=script&lang=js&"
import style0 from "./attrLabelSet.vue?vue&type=style&index=0&id=91be771a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91be771a",
  null
  
)

export default component.exports